import { HStack, Icon, Tag, Text } from '@chakra-ui/react'
import React from 'react'
import { FaFilter } from 'react-icons/fa'

interface Props {
  filterList: string[]
}

const FilterTagList = ({filterList}: Props) => {
  return (
    <HStack position={"absolute"} align={"start"} zIndex={999} top={0} left={0} width={"100vw"} p={4} flexWrap={"wrap"} rowGap={2}>
      <Tag bg={"#2E2E2E"} size={"lg"} px={4} py={2}>
        <Icon boxSize={3} color={"#FF671E"} mr={2} as={FaFilter}/>
        <Text color={"white"}>{filterList.length} Filters</Text>
      </Tag>
      {filterList.map((genre, i) => {
        if (i < 5)
          return (
            <Tag bg={"#B0B0B0"} size={"lg"} px={4} py={2}>
              <Text color={"#505050"}>{genre}</Text>
            </Tag>
          )
        return null
      })}
      {filterList.length > 5 && <Tag bg={"#B0B0B0"} size={"lg"} px={4} py={2}>
        <Text color={"#505050"}>+{filterList.length - 5} more</Text>
      </Tag>}
    </HStack>
  )
}

export default FilterTagList